import { faBan, faCheck, faCreditCard, faFileInvoice, faFolder } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '@ui';
import { useClubSlug } from 'components/Clubs/hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { FilterState, Selection } from '../../DataTable/DataTable';
import useInvoicePath from '../hooks/useInvoicePath';

interface Props {
    global?: boolean;
    clubSlug?: string;
    filter?: FilterState;
    selection?: Selection;
    currency?: string;
}

export const StatusBar: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    clubSlug: _clubSlug,
    filter,
    selection,
    currency: _currency = 'EUR'
}: Props) => {
    const { t } = useTranslation('invoice');
    const clubSlug = useClubSlug(_clubSlug);
    const [path] = useInvoicePath();
    const { data, isLoading } = useSWR(
        `invoice/${clubSlug}/statistics${path === undefined ? '/all' : path ? '/' + path : ''}?filter=${encodeURIComponent(JSON.stringify(filter))}`
    );

    const { invoices_count_cancelled, credit, credit_count, total, total_cancelled, invoices_count, current_category, currency: statisticsCurrency } =
        data?.statistics || {};
    const currency = statisticsCurrency ?? _currency;

    const selectedInvoices = useMemo(() => {
        if (selection === 'all') {
            return invoices_count;
        } else {
            return selection?.length || 0;
        }
    }, [selection, data]);

    return (
        <div className="tw-flex tw-min-h-10 tw-justify-around tw-rounded-xl tw-bg-accents-1 tw-p-2 tw-text-accents-7">
            {isLoading ? (
                <Spinner color="light" size="auto" />
            ) : (
                <div className="tw-flex tw-flex-1 tw-justify-around *:tw-font-bold">
                    <span>
                        <FontAwesomeIcon icon={faFolder} className="tw-mr-2" />
                        {current_category || t('invoiceList.statusBar.rootCategory')}
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faCheck} className="tw-mr-2" />
                        {selectedInvoices}
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faFileInvoice} className="tw-mr-2" />
                        {invoices_count} ({total} {currency})
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faCreditCard} className="tw-mr-2" />
                        {credit_count} ({credit} {currency})
                    </span>
                    <span>
                        <FontAwesomeIcon icon={faBan} className="tw-mr-2" />
                        {invoices_count_cancelled} ({total_cancelled} {currency})
                    </span>
                </div>
            )}
        </div>
    );
};
